import React from 'react';
import { Users, Bed, Calendar, AlertCircle } from 'lucide-react';
import { StatCard } from './StatCard';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  stats: {
    total: number;
    accommodated: number;
    pending: number;
    disputed: number;
  };
};

export const GuideStats = ({ stats }: Props) => {
  const { translations } = useLanguage();

  const statItems = [
    {
      title:
        translations?.guideStats?.registeredPilgrims || 'Registered Pilgrims',
      value: stats.total,
      icon: Users,
      color: 'primary',
    },
    {
      title: translations?.guideStats?.accommodatedPilgrims || 'Accommodated',
      value: stats.accommodated,
      icon: Bed,
      color: 'green',
    },
    {
      title: translations?.guideStats?.notOwner || 'Not Owner',
      value: stats.pending,
      icon: Calendar,
      color: 'yellow',
    },
    {
      title: translations?.guideStats?.disputes || 'Disputes',
      value: stats.disputed,
      icon: AlertCircle,
      color: 'red',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {statItems.map((stat, index) => (
        <StatCard key={stat.title} {...stat} delay={index * 0.1} />
      ))}
    </div>
  );
};